import React from "react";
import logo from "./logo.svg";
import "./App.css";
import ElectionsAnalyzer from "./pages/ElectionsAnalyzer";

function App() {
  return <ElectionsAnalyzer />;
}

export default App;
